<div class="dialog">

  <div class="message">
    <h2 class="info-title">Stored Filters</h2>
  </div>

  <div class="filter-list">
    @for (filter of filterService.storedFilters; track filter.id || filter.name) {
      <div class="filter-item selectable" (click)="selectFilter(filter.name)" [class.selected]="filter === filterService.activeFilter()">
        <div class="filter-name">
          <input type="text" class="form-control filter-name-input" placeholder="Tier Name" maxlength="14" style="color: #bb9e74; font-weight:bold"
            [(ngModel)]="filter.name" (focus)="storeOldName($event)" (keydown)="nameChangeKeyDown($event)" (change)="changeName($event)" (focus)="selectAllText($event)">
        </div>
        <div class="filter-metadata">
          <div><span class="extra-info">Version:</span> {{ filter.version }}</div>
          <div><span class="extra-info">Last Updated:</span> {{ filter.lastUpdated | date:'yyyy-MM-dd' }}</div>
        </div>
        <div class="filter-metadata">
          <div>
            <span class="extra-info">Local:</span>
            @if (filter.filter.id) {
              Yes <span class="filter-id-detail">({{ filter.filter.id }})</span>
            } @else {
              No
            }
          </div>
          <div>
            <span class="extra-info">Account:</span>
            @if (uploadingFilter === filter) {
              ...
            } @else if (filter.id) {
              Yes <span class="filter-id-detail">({{ filter.id }})</span>
            } @else {
              No
            }
          </div>
        </div>
        @if (customRuleTotal(filter.filter) || cosmeticRuleTotal(filter.filter)) {
          <div class="filter-metadata hidden-mobile">
            <div><span class="extra-info">Custom rules:</span> {{ customRuleTotal(filter.filter) }}</div>
            <div><span class="extra-info">Cosmetic rules:</span> {{ cosmeticRuleTotal(filter.filter) }}</div>
          </div>
        }
        <div class="filter-actions tooltip-buttons">
          @if (loggedIn) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="upload($event, filter)" [disabled]="downloadingFilter || uploadingFilter">
                <span class="icon icon-upload"></span>
              </button>
              <ng-template #tooltip>
                Upload to your account
              </ng-template>
            </app-tooltip-wrapper>
          }
          <app-tooltip-wrapper [right]="true" class="btn-tooltip">
            <button type="button" class="btn" (click)="duplicate($event, filter)" [disabled]="downloadingFilter || copyingSections">
              <span class="icon icon-copy"></span>
            </button>
            <ng-template #tooltip>
              Clone
            </ng-template>
          </app-tooltip-wrapper>
          @if (copyingSections && filter === fromFilter) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="copySections($event, filter)" [disabled]="downloadingFilter" [disabled]="true">
                <span class="icon icon-upload2"></span>
              </button>
              <ng-template #tooltip>
                Copying sections from filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (!copyingSections) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="copySections($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-upload2"></span>
              </button>
              <ng-template #tooltip>
                Copy sections to another filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (copyingSections && filter !== fromFilter) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="pasteSections($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-download2"></span>
              </button>
              <ng-template #tooltip>
                Paste sections to this filter
              </ng-template>
            </app-tooltip-wrapper>
          }
          @if (filterService.storedFilters.length > 1) {
            <app-tooltip-wrapper [right]="true" class="btn-tooltip">
              <button type="button" class="btn" (click)="remove($event, filter)" [disabled]="downloadingFilter">
                <span class="icon icon-bin"></span>
              </button>
              <ng-template #tooltip>
                Remove from browser
              </ng-template>
            </app-tooltip-wrapper>
          }
        </div>
      </div>
    }
  </div>

  <button type="button" class="btn create-new-btn" (click)="createNew()">
    Create New
  </button>

  @if (renameError) {
    <div class="message">
      {{ renameError }}
    </div>
  }

  @if (errorUploadingFilter) {
    <div class="message">
      An error occurred trying to update the filter: {{ errorUploadingFilter }}
      <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
    </div>
  }

  @if (!loggedIn) {
    <div class="message">
      <a [href]="null" class="action-link" (click)="login($event)">Log in</a> on pathofexile.com to retrieve account filters.
    </div>
  } @else {
    @if (retrievingFilters) {
      <div class="message">
        Retrieving filters...
      </div>
    } @else {
      @if (errorRetrievingFilters) {
        <div class="message">
          An error occurred trying to retrieve your filters from your pathofexile.com account: {{ errorRetrievingFilters }}
          <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
        </div>
      } @else if (toolAccountFilters.length === 0) {
        <div class="message">
          There are no filters on your pathofexile.com account which have not yet been downloaded.
        </div>
      } @else {
        <div class="message">
          <h2 class="info-title">Account Filters</h2>
          These filters generated with this tool are stored on your pathofexile.com account, but are not yet downloaded on this browser.
          Click the download button to store them in this browser and edit them.
          <span class="extra-info">You can remove filters from your account on your pathofexile.com account page.</span>
        </div>

        <div class="filter-list">
          @for (accountFilter of toolAccountFilters; track accountFilter.id) {
            <div class="filter-item">
              <div class="filter-name" style="padding-left: 12px">
                {{ accountFilter.filter_name }}
              </div>
              <div class="filter-metadata">
                <div><span class="extra-info">Version:</span> {{ accountFilter.version }}</div>
                <div><span class="extra-info">Public:</span> {{ accountFilter.public ? 'Yes' : 'No' }}</div>
              </div>
              <div class="filter-actions tooltip-buttons">
                <button type="button" class="btn" title="Store in browser" (click)="download(accountFilter)" [disabled]="downloadingFilter">
                  <span class="icon icon-download"></span>
                </button>
              </div>
            </div>
          }
        </div>

        @if (errorDownloadingFilters) {
          <div class="message">
            An error occurred trying to download the filter: {{ errorDownloadingFilters }}
            <br />Please try again later. If the problem persists, contact us on Discord or the official forum thread.
          </div>
        }
      }
    }

    @if (otherFilters) {
      <div class="message">
        <h2 class="info-title">Other Filters</h2>
        These filters are stored on your pathofexile.com account, but are not generated with this tool: {{ otherFilters }}
      </div>
    }


    @if (showForceRefresh) {
      <div class="message">
        <a [href]="null" class="action-link" (click)="retrieveFilters($event)">Force refresh</a>. Only use this if you have synced filters to your account from another browser.
      </div>
    }
  }

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Close
    </button>

    @if (copyingSections) {
      <button type="button" class="btn dialog-btn dialog-cancel-copy-btn" (click)="copyingSections = false; fromFilter = null;">
        Cancel Copy Sections
      </button>
    }
  </div>

  @if (showImportDialog) {
    <div id="trade" class="block">
      <div class="search-bar top" style="padding: 0px !important;">
        <app-import-filter-dialog
          [clone]="!copyingSections"
          [apply]="copyingSections"
          [filterResults]="{
            importedName: fromFilter!.name,
            importFilterSuccess: true,
            importFilterError: null,
            importFilterMigratedFrom: null,
            importFilterMigratedTo: null,
            importFilterExportDate: null,
            importFilterExportVersion: null,
            importFilterExportGame: null,
            filter: fromFilter!.filter!
          }"
          [sectionsToUpdate]="{
            quickFilters: !copyingSections,
            myWeapons: !copyingSections,
            myArmour: !copyingSections,
            myJewellery: !copyingSections,
            myJewel: !copyingSections,
            myFlasks: !copyingSections,
            appendToMyEquipment: false,
            tierCosmetics: !copyingSections,
            customCosmeticRules: !copyingSections,
            appendToCustomCosmeticRules: false,
            customRules: !copyingSections,
            appendToCustomRules: false,
            freeRules: !copyingSections,
            customCurrencyAndDivCardTiers: !copyingSections,
            customUniqueTiers: !copyingSections,
            customChanceBaseTiers: !copyingSections,
            customGearTiers: !copyingSections,
            customJewelleryTiers: !copyingSections,
            customModTiers: !copyingSections,
            customEquipmentTiers: !copyingSections,
            identifiedItemConfigs: !copyingSections,
            tieringModeCustom: !copyingSections,
            uniquesTieringModeCustom: !copyingSections,
          }"
          (close)="closeImportDialog()"
          (updateFilter)="updateFilterSections($event)"></app-import-filter-dialog>
      </div>
    </div>
  }

</div>
